import React from "react";
import PropTypes from "prop-types";
import styled from "theme/libs/styled";
import TextStyles from "./text/TextStyles";

const Wrapper = styled("div")`
    position: relative;
    width: 100%;
    padding: ${({ theme }) => theme.space[8]}px 0;
    animation: fadeIn 0.5s linear;
    will-change: opacity;

    @keyframes fadeIn {
        0%,
        99% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    ${({ theme }) => theme.above.tabletLg} {
        padding: ${({ theme }) => theme.space[14]}px 0;
    }
`;

const TextWrapper = styled("div")`
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
`;
const NoResultText = ({ children }) => (
    <Wrapper>
        <TextWrapper>
            <TextStyles textStyles="Buenos Aires/32-120 SemiBold">{children}</TextStyles>
        </TextWrapper>
    </Wrapper>
);

NoResultText.propTypes = {
    children: PropTypes.node.isRequired,
};

export default NoResultText;
